<template>
	<v-dialog v-model="showInfoDialog" width="600" persistent>
		<v-card class="pb-4">
			<v-card-title class="primary">
				<span class="white--text">Optus NBN Order: {{ optusOrderID }}</span>
			</v-card-title>

			<v-card-text class="subtitle-1 pb-0 pt-4">
				<div style="overflow-x: auto;">
					<div class="details-wrapper">
						<table>
							<tr>
								<td colspan="2">ORDER_ID: {{ optusOrderDetails.orderID }}</td>
							</tr>
							<tr>
								<td colspan="2">ORDER_TYPE: {{ optusOrderDetails.orderType }}</td>
							</tr>
							<tr>
								<td colspan="2">LOCATION_ID: {{ optusOrderDetails.locationID }}</td>
							</tr>
							<tr>
								<td colspan="2">ORDER_STATUS: {{ optusOrderDetails.orderStatus }}</td>
							</tr>
							<tr>
								<td colspan="2">PLANNED_COMPLETION_DATE: {{ optusOrderDetails.plannedCompletionDate }}</td>
							</tr>
							<tr>
								<td colspan="2">PRI_ID: {{ optusOrderDetails.priID }}</td>
							</tr>
							<tr>
								<td colspan="2">UNI-DSL: {{ optusOrderDetails.uniDSL }}</td>
							</tr>
							<tr>
								<td colspan="2">BANDWIDTH_PROFILE: {{ optusOrderDetails.bandwidthProfile }}</td>
							</tr>
							<tr>
								<td colspan="2">AVCD: {{ optusOrderDetails.avcd }}</td>
							</tr>
						</table>
						
						<!-- <div class="name text-right py-1">ORDER_ID:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.orderID }}</div>

						<div class="name text-right py-1">ORDER_TYPE:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.orderType }}</div>

						<div class="name text-right py-1">LOCATION_ID:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.locationID }}</div>

						<div class="name text-right py-1">ORDER_STATUS:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.orderStatus }}</div>

						<div class="name text-right py-1">PLANNED_COMPLETION_DATE:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.plannedCompletionDate }}</div>
						
						<div class="name text-right py-1">PRI_ID:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.priID }}</div>

						<div class="name text-right py-1">UNI-DSL:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.uniDSL }}</div>

						<div class="name text-right py-1">BANDWIDTH_PROFILE:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.bandwidthProfile }}</div>
						
						<div class="name text-right py-1">AVCD:</div>
						<div class="name py-1 ml-2">{{ optusOrderDetails.avcd }}</div> -->
					</div>
				</div>
			</v-card-text>

			<v-card-actions class="mt-2">
				<v-spacer></v-spacer>
				<v-btn
					class="mr-3 primary"
					@click="$emit('close')"
					>Close</v-btn
				>
			</v-card-actions>
		</v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: "OrderInfo",
		props: {
			showInfoDialog: { type: Boolean, required: true },
			optusOrderID: { type: String, required: true }
		}
	}
</script>

<style lang="scss" scoped>
.name {
	width: 250px;
	display: inline-block;
}
.inline {
	display: inline;
}

@media screen and (max-width: 1100px) {
  .details-wrapper {
    width: 600px
  }
}
table, tr{
  border-bottom: 1px solid;
}

table {
  width: 100%;
  border-collapse: collapse;
}
</style>